import { cardAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const tableCardAnatomy = cardAnatomy.extendWith('contentBlock', 'titleBlock');

const tableCardSlotRecipe = defineSlotRecipe({
  className: 'table-card',
  slots: tableCardAnatomy.keys(),
  base: {
    root: {
      overflow: 'hidden',
    },
    header: {
      backgroundColor: 'background/secondary',
      borderBottomColor: 'border/regular',
      borderBottomStyle: 'solid',
      borderBottomWidth: '1',
      paddingBlock: '16',
      paddingInline: { base: '16', tablet: '24' },
    },
    contentBlock: {
      alignItems: 'center',
      display: 'flex',
      gap: '16',
      justifyContent: 'space-between',
    },
    titleBlock: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: '4',
      minWidth: 0,
    },
    title: {
      color: 'text/primary',
      textStyle: { base: 'heading/h3', tablet: 'heading/h4' },
    },
    description: {
      color: 'text/secondary',
      textStyle: 'body/md/regular',
    },
    body: {
      backgroundColor: 'background/primary',
      padding: 0,
    },
  },
});

export default tableCardSlotRecipe;
